import { Plus, Trash2, History } from "lucide-react";
import { brandStyle } from "../../utils/branding";

export default function Sidebar({
  isOpen,
  setIsOpen,
  config,
  userInfo,
  conversations,
  currentConvId,
  onSelectConv,
  onDeleteConv,
}) {
  return (
    <>
      <aside
        className={`fixed inset-y-0 left-0 z-50 w-72 bg-white border-r border-stone-100 transform transition-transform duration-300 ease-in-out lg:relative lg:transtone-x-0 ${isOpen ? "transtone-x-0" : "-transtone-x-full"} flex flex-col shadow-xl lg:shadow-none`}
      >
        <div className="p-4 border-b border-stone-50 flex items-center justify-between bg-stone-50/30">
          <div className="flex items-center gap-2">
            <div
              className="size-8 rounded-lg flex items-center justify-center"
              style={brandStyle(config)}
            >
              <History size={18} />
            </div>
            <span className="font-bold text-stone-700 text-sm tracking-tight uppercase">
              Historique
            </span>
          </div>
          <button
            onClick={() => onSelectConv(null)}
            className="p-2 rounded-lg text-stone-500 hover:text-white hover:bg-stone-900 transition-all border border-stone-200 bg-white"
            title="Nouvelle conversation"
          >
            <Plus size={18} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-3 space-y-1.5 scrollbar-hide">
          {Array.isArray(conversations) &&
            conversations.map((c) => (
              <div
                key={c.id}
                role="button"
                tabIndex={0}
                className={`group relative flex items-center p-3 rounded-xl cursor-pointer transition-all border ${currentConvId === c.id ? "bg-stone-50 border-stone-200 shadow-sm" : "hover:bg-stone-50/50 border-transparent"}`}
                onClick={() => {
                  onSelectConv(c.id);
                  if (window.innerWidth < 1024) setIsOpen(false);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onSelectConv(c.id);
                    if (window.innerWidth < 1024) setIsOpen(false);
                  }
                }}
              >
                <div className="flex-1 min-w-0 pr-8">
                  <div
                    className={`truncate text-sm font-semibold ${currentConvId === c.id ? "text-stone-900" : "text-stone-600 group-hover:text-stone-900"}`}
                  >
                    {c.title || "Sans titre"}
                  </div>
                  <div className="text-[10px] text-stone-400 mt-1 uppercase tracking-wider font-medium flex items-center gap-1.5" suppressHydrationWarning>
                    <span>
                      {new Date(c.created_at).toLocaleDateString("fr-FR")}
                    </span>
                    <span>&bull;</span>
                    <span>
                      {c.messages_count || 0}{" "}
                      {c.messages_count === 1 ? "question" : "questions"}
                    </span>
                  </div>
                </div>
                <button
                  className="absolute right-3 opacity-0 group-hover:opacity-100 p-1.5 text-stone-500 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteConv(c.id);
                  }}
                >
                  <Trash2 size={14} />
                </button>
              </div>
            ))}
          {conversations.length === 0 && (
            <div className="text-center p-8 text-stone-400 text-sm italic bg-stone-50/50 rounded-2xl border border-dashed border-stone-200 mt-4">
              Aucune conversation
            </div>
          )}
        </div>

        <div className="p-4 border-t border-stone-100 bg-stone-50/30">
          <div className="flex items-center gap-3 p-2 rounded-xl">
            <div className="size-10 rounded-xl bg-white border border-stone-200 flex items-center justify-center font-bold text-stone-700 text-sm shadow-sm">
              {userInfo?.username?.[0]?.toUpperCase()}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-bold text-stone-900 truncate">
                {userInfo?.username}
              </div>
              <div className="text-[10px] text-stone-400 uppercase tracking-widest font-bold truncate">
                {userInfo?.subclient || "Admin"}
              </div>
            </div>
          </div>
        </div>
      </aside>

      {isOpen && (
        <div
          className="fixed inset-0 bg-stone-900/40 backdrop-blur-sm z-40 lg:hidden"
          role="button"
          tabIndex={0}
          onClick={() => setIsOpen(false)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setIsOpen(false);
            }
          }}
        />
      )}
    </>
  );
}
